import {Network} from './network';

const network = new Network(process.env.VUE_APP_DICTIONARY_API_BASE);

export default {
  findWord(wordCn) {
    return network.api.get('word', {params: {search_cn: wordCn}});
  },
};
